/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

class Title extends Component {
  render() {
    const { children } = this.props;
    return (
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        {children}
      </Typography>
    );
  }
}

Title.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Title;
